import { useLocation } from "react-router-dom";
import { createContext, useState, useContext } from "react";

const SESSION_STORAGE_KEY = "InternalReferrerProvide_referrerData";

const internalReferrerContext = createContext();

function peek(stack, distanceFromTop = 0) {
    return stack?.length > distanceFromTop ? stack[stack.length - (distanceFromTop + 1)] : null;
}

// context provider to track the referrer as a replacement for document.referrer since it's generally unavailable in modern browsers,
// only tracks internal navigation
// todo: consider giving users the whole 'location' object from the stack instead of just 'referrer'
// todo: consider preserving future navigation history in stack and giving consumers that too
export function InternalReferrerProvider({ children }) {
    const location = useLocation();

    const [stack, _setStack] = useState(JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY)));
    const setStack = (s) => {
        sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(s));
        _setStack(s);
    };

    // Update if key changed (key doesn't change for things like
    // page refreshes which we ignore, like the history stack does)
    if (peek(stack)?.key !== location.key) {
        let newStack = stack || [];

        {
            // update stack
            // find index of existing record of this nav item (if any)
            const index = newStack.findIndex((item) => item.key === location.key);
            if (index === -1) {
                // if the stack doesn't have it, push it
                newStack.push(location);
            } else {
                // if the stack already has it, just pop everything above it off
                newStack = newStack.slice(0, index);
            }
        }

        setStack(newStack);
    }

    return (
        <internalReferrerContext.Provider value={{ referrer: peek(stack, 1)?.pathname }}>
            {children}
        </internalReferrerContext.Provider>
    );
}

export const useInternalReferrer = () => useContext(internalReferrerContext);

//higher-order component to pass the referrer to a class component
export const withInternalReferrer = (WrappedComponent) => (props) => {
    const referrer = useInternalReferrer()?.referrer;
    return <WrappedComponent {...props} {...{ referrer }} />;
};
